export default __webpack_public_path__ + "static/media/pig.7f1e923b.png";